import { supabase } from './supabase';

// fetch() wrapper for the app's own /api routes — attaches the signed-in
// user's access token, which the server requires on every /api request.
export async function apiFetch(input: string, init: RequestInit = {}): Promise<Response> {
  const { data: { session } } = await supabase.auth.getSession();
  const headers = new Headers(init.headers);
  if (session?.access_token) {
    headers.set('Authorization', `Bearer ${session.access_token}`);
  }
  return fetch(input, { ...init, headers });
}
